module.exports = __webpack_public_path__ + "static/media/sky-terrace-3.6192552a.jpg";